import { Component, Input, OnChanges } from '@angular/core';

import { ChartPointModel }           from '../typings/intelligence.chart-point';
import { ChartSeriesModel }          from '../typings/intelligence.chart-series';
import { ChartTooltipModel }         from '../typings/intelligence.chart-tooltip';
import { IntelligenceFormatService } from '../intelligence.format.service';

interface RenderedRow {
  bars : Array<{ color : string; percent : number; }>;
  label: string;
  point: ChartPointModel;
  value: string;
}

@Component({
  selector   : 'wor-intelligence-hbar-chart',
  template: require('./intelligence.hbar-chart.component.html')
})
export class HbarChartComponent implements OnChanges {
  @Input() format = 'money';
  @Input() points : Array<ChartPointModel> = [];
  @Input() series : Array<ChartSeriesModel> = [];

  rows : Array<RenderedRow> = [];
  tooltip : ChartTooltipModel = { rows: [], title: '', visible: false, x: 0, y: 0 };

  constructor (
    private intelligenceFormatService: IntelligenceFormatService
  ) {}

  ngOnChanges () : void {
    this.render();
  }

  formatValue ( value : number ) : string {
    return this.format === 'count'
      ? this.intelligenceFormatService.count(value)
      : this.intelligenceFormatService.money(value);
  }

  hideTooltip () : void {
    this.tooltip = { ...this.tooltip, visible: false };
  }

  onMove ( event : MouseEvent, row : RenderedRow ) : void {
    const wrapper = ( event.currentTarget as HTMLElement ).closest('.intelligence-chart-wrapper') as HTMLElement;
    const bounds = wrapper.getBoundingClientRect();

    this.tooltip = {
      rows: this.series.map(item => ({
        color: item.color,
        label: item.label,
        value: this.formatValue(row.point.values[ item.key ] || 0)
      })),
      title  : row.label,
      visible: true,
      x      : Math.min(event.clientX - bounds.left + 14, bounds.width - 170),
      y      : Math.max(event.clientY - bounds.top - 10, 4)
    };
  }

  private render () : void {
    this.hideTooltip();
    this.rows = [];

    if ( !this.points.length || !this.series.length ) {
      return;
    }

    let max = 0;

    this.points.forEach(point => {
      this.series.forEach(item => max = Math.max(max, point.values[ item.key ] || 0));
    });

    if ( max <= 0 ) {
      max = 1;
    }

    this.rows = this.points.map(point => ({
      bars: this.series.map(item => ({
        color  : item.color,
        percent: Math.max((( point.values[ item.key ] || 0 ) / max ) * 100, 0)
      })),
      label: point.label,
      point,
      value: this.formatValue(point.values[ this.series[ 0 ].key ] || 0)
    }));
  }
}
